import { render, staticRenderFns } from "./IOTStationConfig.vue?vue&type=template&id=f1494e10&scoped=true"
import script from "./IOTStationConfig.vue?vue&type=script&lang=js"
export * from "./IOTStationConfig.vue?vue&type=script&lang=js"
import style0 from "./IOTStationConfig.vue?vue&type=style&index=0&id=f1494e10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1494e10",
  null
  
)

export default component.exports